import { render, staticRenderFns } from "./UserDetailModal.vue?vue&type=template&id=4cecf9b2&scoped=true"
import script from "./UserDetailModal.vue?vue&type=script&lang=js"
export * from "./UserDetailModal.vue?vue&type=script&lang=js"
import style0 from "./UserDetailModal.vue?vue&type=style&index=0&id=4cecf9b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cecf9b2",
  null
  
)

export default component.exports